/**
 *
 * Classe para formatar os dados do tipo texto
 * @author: Adalto Junior
 * 11/08/2014
 *
 */


Monet.Format = Monet.Format || {};
Monet.Format.TEXT = (function () {

    function TEXT(value) {
        Monet.Format.Base.apply(this, arguments);
    }

    return TEXT;

}());

